<template>
  <div class="login">

    <div class="zwf">
      <img width="100%" src="@/assets/Snipaste_2023-11-29_18-18-20.jpg" alt="">
    </div>

    <div class="formBoxA">
      <div class="formBox">
        <div class="formBox_title"><span :class='{okform :formData.name}' class="red">*</span>姓名</div>
        <div class="formBox_inp">
          <a-input v-model='formData.name' placeholder='请填写您的姓名' />
        </div>
      </div>

      <div class="formBox">
        <div class="formBox_title"><span :class='{okform :formData.hospital}' class="red">*</span>医院</div>
        <div class="formBox_inp">
          <a-input v-model='formData.hospital' placeholder='请填写您所在的医院名称' />
        </div>
      </div>

      <div class="formBox">
        <div class="formBox_title"><span :class='{okform :formData.department}' class="red">*</span>科室</div>
        <div class="formBox_inp">
          <a-input v-model='formData.department' placeholder='请填写您所在的科室名称' />
        </div>
      </div>

      <div class="formBox">
        <div class="formBox_title"><span :class='{okform :formData.title}' class="red">*</span>职称</div>
        <div class="formBox_inp">
          <a-select v-model='formData.title' :class='{noinp :!formData.title}' placeholder="请选择您的职称">
            <a-select-option value="">
              请选择您的职称
            </a-select-option>
            <a-select-option value="主任医师">
              主任医师
            </a-select-option>
            <a-select-option value="副主任医师">
              副主任医师
            </a-select-option>
            <a-select-option value="主治医师">
              主治医师
            </a-select-option>
            <a-select-option value="其他">
              其他
            </a-select-option>
          </a-select>
        </div>
      </div>

      <div class="formBox asd">
        <div class="formBox_title"><span :class='{okform :formData.phone}' class="red">*</span>联系方式</div>
        <div class="formBox_inp">
          <a-input v-model='formData.phone' placeholder='请填写您的联系方式' />
        </div>
      </div>

      <div class="fsumitox">
        <div @click="okBox" class="sumit">确认提交</div>
      </div>

      <!-- <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" @submit="handleSubmit">

        <a-form-item label="姓名">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请填写您的姓名!' }] }]" />
        </a-form-item>

        <a-form-item label="医院">
          <a-input v-decorator="['hospital', { rules: [{ required: true, message: '请填写您的医院!' }] }]" />
        </a-form-item>

        <a-form-item label="科室">
          <a-input v-decorator="['department', { rules: [{ required: true, message: '请填写您的科室!' }] }]" />
        </a-form-item>

        <a-form-item label="职称">
          <a-select v-decorator="[
          'title',
          { rules: [{ required: true, message: '请选择您的职称!' }] },
        ]" placeholder="请选择您的职称">
            <a-select-option value="主任医师">
              主任医师
            </a-select-option>
            <a-select-option value="副主任医师">
              副主任医师
            </a-select-option>
            <a-select-option value="主治医师">
              主治医师
            </a-select-option>
            <a-select-option value="其他">
              其他
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="联系方式">
          <a-input v-decorator="['phone', { rules: [
      {pattern: /^1[3456789]\d{9}$/,message: '电话号码格式错误！'},
      { required: true, message: '请填写您的联系方式!' }
      ] }]" />
        </a-form-item>

        <a-form-item class="loginBtn">
          <a-button type="primary" html-type="submit">
            Submit
          </a-button>
        </a-form-item>

      </a-form> -->
    </div>

    <backHomeVue @click="gohome" :baseData='baseData'></backHomeVue>
  </div>
</template>

<script> 
import backHomeVue from '../../components/backHome.vue';
import { login, getWXConfig } from '@/api/login.js';
export default {
  components: { backHomeVue },
  data() {
    return {
      baseData: {
        home_page_id: 2
      },
      formData: {
        name: '',
        hospital: '',
        department: '',
        title: '',
        phone: '',
      },
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  created() {
    this.share()
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values.meeting_id = this.$route.query.meeting_id;
          await login(values);
        }
      });
    },

    async okBox() {
      this.formData.meeting_id = this.$route.query.meeting_id;
      console.log(this.formData);
      for (const key in this.formData) {
        if (!this.formData[key]) {
          return this.$message.error('请填写完整信息！');
        }
      }


      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!reg.test(this.formData.phone)) {
        return this.$message.error('请填写正确手机号！');
      }

      await login(this.formData);
      this.$message.success('提交成功！')
      let _this = this
      setTimeout(function () {
        _this.$router.go(0)
      }, 300)
    },
    async share() {

      let data = await getWXConfig({ url: window.location.href })

      this.WXConfig.wxShowMenu(
        data.payload,
        '报名参会',
        "http://zlwc.xoncology.com/storage/app/setmeet/2023-11/6Ey8IlqH6UagGOhLSsPdda3qM8cztqArQs9KSe8G.png",
        '第九届上海肿瘤微创治疗学术会议' + "\r\n" + '2023年12月16日',
        '报名参会' + " | " + '第九届上海肿瘤微创治疗学术会议2023上海市抗癌协会肿瘤微创治疗专业委员会年会' + "\r\n" + '2023年12月16日',
      );

    },
    gohome() {
      // this.$router.push('/')
    }
  },
};
</script>

<style scoped>
.formBoxA {
  padding: 0 38px;
  padding-top: 40px;
  background: #fff;
}
.login {
  width: 100%;
  overflow: hidden;
  min-height: 100vh;
  background: url("~@/assets/编组 4@2x (3).png") no-repeat;
  background-size: 100% 100%;
}
.loginBtn {
  text-align: center;
}
.formBox {
  display: flex;
  height: 60px;
  border-bottom: 1px solid #e0e6ea;
}
.red {
  color: red;
}
.okform {
  color: green;
}
.noinp {
  color: #bfbfbf;
}
.formBox_title {
  line-height: 60px;
  font-size: 15px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #232323;
  margin-right: 60px;
}
.formBox_inp {
  flex: 1;
  padding: 5px 0;
}
.fsumitox {
  margin: 0;
  margin-top: 30px;
}
.sumit {
  width: 100%;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  background: linear-gradient(180deg, #4cadf1 0%, #25a3df 100%);
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
}
</style>

<style>
.login .ant-input {
  height: 100%;
  border: 0px;
}
.login .ant-select {
  width: 100%;
  height: 100%;
  border: 0px;
}
.login .ant-select-selection {
  width: 100%;
  height: 100%;
  line-height: 50px;
  border: 0px;
}
.login .ant-select-selection__rendered {
  width: 100%;
  height: 100%;
  border: 0px;
  line-height: 50px;
}
.login .asd .formBox_title {
  margin-right: 30px;
}

/* .login input:focus {
  outline: 1px solid #51c9ff;
  background: rgba(3, 16, 28, 0);
} */
</style>